import React, { useEffect, useMemo, useRef, useState } from "react";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import MainLayout from "../MainLayout";
import FormControl from "@material-ui/core/FormControl";
import GetAppIcon from "@material-ui/icons/GetApp";
import ListCustomerComponent from "../../components/ListCustomer";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import FormDialog from "../../components/FormDialog";
import ButtonComponent from "../../components/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormLabel from "@material-ui/core/FormLabel";
import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import types from "../../constants/types";
import moment from "moment";
import IMAGES from "../../images";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DeleteIcon from "@material-ui/icons/Delete";
import Loading from "../../components/Loading";
import { getFanpageDetail } from "views/Fanpage/FanpageActions";
import { useDispatch, useSelector } from "react-redux";
import Flex from "components/Flex";
import BaseSelectFile from "components/BaseSelectFile";
import cn from "classnames";
import { selectFilterCus, selectImportResult } from "./CustomerSelectors";
import Tour from "reactour";
import { selectSearchUidName } from "./CustomerSelectors";
import {
  getIsGuideByKey,
  GUIDE_TYPE_ENUM,
  setIsGuideByKey
} from "utils/helper";
import { selectGuideListByKey } from "stores/config/config.selector";
import ModalResultImport from "./item/ModalResultImport";
import { useTranslation } from "react-i18next";
import MessengerButton from "./../Home/items/MessengerButton";
import TagPreviewItem from "../../components/TagPreviewItem";
import { colorDir1, getRandomTag } from "../../components/TagPreviewModal";
import VirtualScroll from "../../components/VirtualScroll";
import LoadingWrapper from "components/LoadingWrapper";
import listStyles from "../../components/ListCustomer.module.scss";
import { X } from "lucide-react";

const useStyles = makeStyles((theme) => ({
  wrapSelectFanpage: {
    marginTop: 30,
    // width: 'calc(100% - 15px)',
    width: "100%",
    "& h4": {
      marginBottom: 5,
      color: "#05AE34",
      fontSize: 16
    }
  },
  wrapSelect: {
    width: "100%",
    marginTop: "12px",
    marginBottom: "12px"
  },
  select: {
    // margin: "5px 0px !important",
  },
  wrapSelectLabel: {
    zIndex: 1,
    fontSize: 16,
    paddingLeft: 10,
    marginTop: 7,
    "&.MuiFormLabel-filled": {
      display: "none !important"
    },
    "&.Mui-focused": {
      display: "none !important"
    }
  },

  root: {
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5"
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)"
    }
  },
  checkedIcon: {
    backgroundColor: "#05AE34",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""'
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3"
    }
  },
  wrapRadioGroup: {
    display: "inline-block",
    flexWrap: "inherit",
    flexDirection: "inherit",
    marginLeft: 15,
    fontSize: "16px",
    marginTop: 10
  },
  // wrapperPopup: {
  //   "& h4": {
  //     color: "#05AE34",
  //     paddingLeft: 15,
  //   },
  //   "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
  //     top: "-25px",
  //     color: "rgba(0, 0, 0, 0.87) !important",
  //     width: "100%",
  //     fontSize: "16px",
  //     transform: "inherit",
  //   },
  //   "& .MuiInputLabel-filled": {
  //     top: "-25px",
  //     color: "rgba(0, 0, 0, 0.87) !important",
  //     width: "100%",
  //     fontSize: "16px",
  //     transform: "inherit",
  //   },
  //   "& .MuiFilledInput-input": {
  //     padding: "10px 12px 10px 2px !important",
  //   },
  // },
  // radioGroup: {
  //   flexWrap: "inherit",
  //   flexDirection: "inherit",
  //   "& label": {
  //     float: "left",
  //   },
  // },
  // textField: {
  //   width: "100%",
  //   padding: "0px 15px",
  //   margin: "35px 0px 10px 0px",
  //   "& .MuiInputLabel-filled": {
  //     marginLeft: 15,
  //   },
  // },
  formControlCheckbox: {
    margin: "15px 0px 0px 15px",
    width: "calc(100% - 30px)",
    "& .MuiFormLabel-root": {
      marginBottom: 5,
      fontSize: 16
    },
    "& .MuiFormControlLabel-label": {
      fontSize: 16
    },
    "& .MuiCheckbox-colorSecondary.Mui-checked": {
      color: "#05AE34"
    },
    "& .MuiFormLabel-root": {
      color: "rgba(0, 0, 0, 0.87)",
      fontSize: 16
    }
  },
  wrapButton: {
    width: "100%",
    display: "inline-block"
  },
  button: {
    display: "inline-block",
    width: 130,
    float: "right",
    margin: "30px 15px 30px 0px"
  },
  title: {
    color: "#05AE34"
  },
  wrapButtonImport: {
    textAlign: "right"
  },
  wrapBox: {
    padding: "15px 42px 30px 15px"
  },
  buttonChange: {
    margin: "0px 0px 0px 10px"
  },
  importInput: {
    margin: "15px 0px 30px 0px"
  },
  inboxDate: {
    left: 15,
    top: -5,
    width: 200,
    marginTop: 25,
    // marginwrapperPopupwrapperPopupTop: 25,
    "& label": {
      color: "rgba(0, 0, 0, 0.87) !important",
      fontSize: "16px",
      transform: "inherit",
      top: "-10px",
      width: "100%"
    },
    "& .MuiInputBase-formControl": {
      width: 140
    },
    "& $root": {
      width: 120
    },
    "& .MuiInputBase-input": {
      width: 120,
      position: "absolute",
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      opacity: 0,
      cursor: "pointer",
      boxSizing: "border-box"
    },
    "& .MuiInputBase-input::-webkit-calendar-picker-indicator": {
      position: "absolute",
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      margin: 0,
      padding: 0,
      cursor: "pointer"
    }
  },
  inboxTime: {
    left: 15,
    top: -5,
    width: 200,
    marginTop: 25,
    // marginwrapperPopupwrapperPopupTop: 25,
    "& label": {
      color: "rgba(0, 0, 0, 0.87) !important",
      fontSize: "16px",
      transform: "inherit",
      top: "-10px",
      width: "100%"
    },
    "& .MuiInputBase-formControl": {
      width: 140
    },
    "& $root": {
      width: 120
    }
  },
  inboxTimeLast: {
    right: 30,
    position: "absolute",
    top: -5,
    marginTop: 25,
    // marginwrapperPopupwrapperPopupTop: 25,
    "& label": {
      color: "rgba(0, 0, 0, 0.87) !important",
      fontSize: "16px",
      transform: "inherit",
      top: "-10px",
      width: "100%"
    },
    "& .MuiInputBase-formControl": {
      width: 140
    },
    "& $root": {
      width: 120
    },

    "& .MuiInputBase-input::-webkit-calendar-picker-indicator": {
      position: "absolute",
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      margin: 0,
      padding: 0,
      cursor: "pointer"
    }
  },
  wrapperLoading: {
    height: 100,
    position: "relative",
    textAlign: "center",
    top: -20,
    "& img": {
      height: 100,
      position: "absolute",
      top: 0,
      left: "calc(50% - 50px)",
      width: 100
    },
    "& p": {
      position: "absolute",
      bottom: -11,
      textAlign: "center",
      width: "100%"
    }
  },
  noData: {
    marginTop: 15,
    marginBottom: 10,
    color: "rgba(0, 0, 0, 0.38)"
  },
  addTag: {
    width: "100%",
    marginBottom: 15
  },
  wrapCheckbox: {
    position: "relative",
    "&:hover": {
      "& $delete": {
        display: "inline-block"
      }
    }
  },
  delete: {
    display: "none",
    position: "absolute",
    right: "-8%",
    top: "50%",
    transform: "translateY(-50%)",
    "&:hover": {
      cursor: "pointer"
    }
  },
  wrapButtonPopup: {
    textAlign: "right",
    paddingBottom: 30,
    paddingRight: 15
  },
  tagFormGroup: {
    // height: '200px',
    // overflowY: 'auto',
    // overflowX: 'hidden',
    display: "initial",
    marginTop: "15px",
    "& .MuiFormControlLabel-root": {
      width: "100%"
    }
  },
  fromToIcon: {
    position: "absolute",
    top: "45px",
    left: "180px"
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    paddingTop: '5px'
  },
  dialog: {
    borderRadius: "12px",
    maxWidth: '480px'
  },
  dialogTitle: {
    position: "relative"
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  underline: {
    textDecoration: "none",
    fontWeight: 600,
    color: "#06ae34",
    borderBottom: "1px solid #06ae34",
    paddingBottom: "0.5px",
    "&:hover": {
      color: "#6c757d",
      borderBottom: "1px solid #6c757d"
    },
    "&:focus": {
      outline: "none"
    }
  }
}));

function StyledRadio(props) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}

const CustomerView = (props) => {
  const classes = useStyles();

  const {
    getFanpage,
    getCustomer,
    fanpageFull,
    customer,
    onDetail,
    onEdit,
    detail,
    getListTagFacebook,
    onFanpageSelected,
    fanpageSelected,
    getListTagBombot,
    onExport,
    removeCustomer,
    fileUpload,
    loadingImport,
    importSuccess,
    onSubmitAddTag,
    loading,
    onCreate,
    getCustomerAll,
    customerAll,
    customerCheck,
    onCustomerCheck,
    onCustomerCheckReset,
    createCustomerSucss,
    resetCustomer,
    messageImport
  } = props;
  const [data, setData] = useState([]);
  const [isPopup, setIsPopup] = useState(false);
  const [detailState, setDetailState] = useState({});
  const [listTagFacebook, setListTagFacebook] = useState([]);
  const [listTagBombot, setListTagBombot] = useState([]);
  const [tagFbSelectedAll, setTagFbSelectedAll] = useState(false);
  const [tagBbSelectedAll, setTagBbSelectedAll] = useState(false);
  const [isActions, setIsActions] = useState(null);
  const [file, setFile] = useState({});
  const [isImportPopup, setIsImportPopup] = useState(false);

  const [listTagPancake, setListTagPancake] = useState([]);

  const [uid, setUid] = useState(null);
  const [nameFacebook, setNameFacebook] = useState(null);
  const [lastInboxTime, setLastInboxTime] = useState(null);
  const [lastInboxTimeTo, setLastInboxTimeTo] = useState(null);

  // const [tagFacebook, setTagFacebook] = useState([]);
  // const [tagBombot, setTagBombot] = useState([]);
  const [gender, setGender] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [isAddTag, setIsAddTag] = useState(false);
  const [addTag, setAddTag] = useState("");
  const [listBombotTag, setListBombotTag] = useState([]);
  const [isConfirmDeleteTag, setIsConfirmDeleteTag] = useState(false);
  const [itemDelete, setItemDelete] = useState({});
  const [isCreateCampaign, setIsCreateCampaign] = useState(false);
  const [paramsFilter, setParamsFilter] = useState(undefined);
  const [messageAddTag, setMessageAddTag] = useState("");
  const [urlSearchParamPageId, setUrlSearchParamPageId] = useState(undefined);
  const [urlSearchParamSearch, setUrlSearchParamSearch] = useState("");
  const [urlSearchParamPage, setUrlSearchParamPage] = useState(
    types.PAGINATION.PAGE
  );
  const [urlSearchParamSize, setUrlSearchParamSize] = useState(
    types.PAGINATION.SIZE
  );

  const [lastCustomerInboxTimeTo, setLastCustomerInboxTimeTo] = useState(null);
  const [lastCustomerInboxTime, setLastCustomerInboxTime] = useState(null);

  const importResult = useSelector(selectImportResult);
  const searchUidName = useSelector(selectSearchUidName);

  const [urlSearchParamSort, setUrlSearchParamSort] =
    useState("createdAt,desc");
  const [message, setMessage] = useState("");
  const [typeIdentif, setTypeIdentif] = useState("CONVERSATION_ID");
  const dispatch = useDispatch();
  const history = useHistory();
  const [selectedPageId, setSelectedPageId] = useState(
    fanpageSelected.id || null
  );

  const tourOverview = useSelector(
    selectGuideListByKey(GUIDE_TYPE_ENUM.customer_manager)
  );

  const filterCustomerExport = useSelector(selectFilterCus);
  const searchUidNameExport = useSelector(selectSearchUidName);

  const { t } = useTranslation();

  const [tourConfig, setTourConfig] = useState(null);

  const [openPopupScanCustomer, setOpenPopupScanCustomer] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const lastFanpageFullRef = useRef(null);

  useEffect(() => {
    if (
      getIsGuideByKey(GUIDE_TYPE_ENUM.customer_manager) &&
      tourOverview?.length
    ) {
      setTourConfig(tourOverview);
      setIsGuideByKey(GUIDE_TYPE_ENUM.customer_manager);
    }
  }, [tourOverview]);

  useEffect(() => {
    if (!importSuccess) {
      setMessage(messageImport?.message);
    }
  }, [messageImport]);

  useEffect(() => {
    if (fanpageFull) {
      // Skip if fanpageFull is the same reference (already processed)
      if (lastFanpageFullRef.current === fanpageFull) {
        return;
      }
      lastFanpageFullRef.current = fanpageFull;

      const searchParam = new URLSearchParams(window.location.search);
      let pageId = searchParam.get("pageId");
      const page = searchParam.get("page");
      const size = searchParam.get("size");
      const sort = searchParam.get("sort");
      const search = searchParam.get("search");
      if (pageId) {
        setUrlSearchParamPageId(pageId);
      }
      if (!pageId && fanpageFull[0]) {
        pageId = fanpageFull[0].id;
        setUrlSearchParamPageId(fanpageFull[0].id);
      }
      if (page) {
        setUrlSearchParamPage(page);
      }
      if (size) {
        setUrlSearchParamSize(size);
      }
      if (sort) {
        setUrlSearchParamSort(sort);
      }
      if (search) {
        setUrlSearchParamSearch(search);
      }
      const fanpageCurrent = fanpageFull.find((item) => item.id == pageId);

      if (fanpageCurrent) {
        onFanpageSelected(fanpageCurrent);
        getCustomer({
          page: page,
          size: size,
          search: `${
            urlSearchParamSearch
              ? urlSearchParamSearch
              : `pageId==${fanpageCurrent.id ? fanpageCurrent.id : undefined}`
          }`,
          sort: sort
        });
      } else {
        resetCustomer();
        onFanpageSelected({});
      }
    }
  }, [fanpageFull]);

  const filterCus = useSelector(selectFilterCus);

  useEffect(() => {
    if (filterCus?.search_string) {
      let searchQuery = filterCus?.search_string;

      if (!_.isEmpty(searchUidName)) {
        searchQuery += `;uid|name==` + searchUidName;
      }

      getCustomer({
        page: 0,
        size: 10,
        search: searchQuery,
        sort: "lastInboxTime,desc"
      });
    }
  }, [filterCus?.search_string]);

  useEffect(() => {
    if (isPopup) {
      let listTagBombotTmp = sortListTag(getListTagBombot);
      setListTagBombot(listTagBombotTmp);
    }
  }, [getListTagBombot, isPopup]);

  useEffect(() => {
    if (isPopup) {
      let listTagFbTmp = sortListTag(getListTagFacebook);
      setListTagFacebook(listTagFbTmp);
    }
  }, [getListTagFacebook, isPopup]);

  useEffect(() => {
    if (importSuccess) {
      getCustomer({
        page: types.PAGINATION.PAGE,
        size: types.PAGINATION.SIZE,
        search: `pageId==${fanpageSelected.id}`,
        sort: "lastInboxTime,desc"
      });
      setIsImportPopup(false);
    }
  }, [importSuccess]);

  useEffect(() => {
    setData(customer);
  }, [customer]);

  useEffect(() => {
    setDetailState(detail);
    setUid(detail.uid);
    setNameFacebook(detail.name);
    setLastInboxTime(detail.updatedAt);
    setGender(detail.gender);
  }, [detail]);

  useEffect(() => {
    setData([]);
    onCustomerCheckReset([]);
    // Only fetch fanpage if not already available in Redux
    // (avoids re-dispatch which causes fanpageFull useEffect to re-trigger)
    if (!fanpageFull || fanpageFull.length === 0) {
      const params = {};
      getFanpage(params);
    }
  }, []);

  const handleChangeFanpage = (key, value) => {
    switch (key) {
      case "fanpage":
        if (value) {
          onFanpageSelected(value);
          getCustomer({
            page: types.PAGINATION.PAGE,
            size: types.PAGINATION.SIZE,
            search: `pageId==${value.id ? value.id : undefined}`,
            sort: "lastInboxTime,desc"
          });

          const searchParam = new URLSearchParams(window.location.search);
          searchParam.set("page", types.PAGINATION.PAGE);
          searchParam.set("size", types.PAGINATION.SIZE);
          searchParam.set("pageId", `${value.id ? value.id : undefined}`);
          searchParam.set("sort", "lastInboxTime,desc");
          searchParam.delete("search");
          searchParam.delete("query");
          const newSearchParam = searchParam.toString();
          history.push({
            pathname: window.location.pathname,
            search: newSearchParam
          });
          dispatch(getFanpageDetail(value.id));
        }
        break;
      default:
        break;
    }
  };

  const handleCheckedAllTagFacebook = (event) => {
    const items = [];
    if (tagFbSelectedAll) {
      (listTagFacebook || []).map((item) => {
        items.push({
          ...item,
          checked: false
        });
      });
    } else {
      (listTagFacebook || []).map((item) => {
        items.push({
          ...item,
          checked: true
        });
      });
    }
    setListTagFacebook(items);
    setTagFbSelectedAll(!tagFbSelectedAll);
  };

  const handleCheckedAllTagBombot = () => {
    if (tagBbSelectedAll) {
      const updatedTags = listTagBombot.map((tag) => ({
        ...tag,
        checked: false
      }));
      setListTagBombot(updatedTags);
    } else {
      const updatedTags = listTagBombot.map((tag) => ({
        ...tag,
        checked: tag.name !== "Không có tag"
      }));
      setListTagBombot(updatedTags);
    }
    setTagBbSelectedAll(!tagBbSelectedAll);
  };

  const handleCheckedTagBombot = (item) => {
    setTagBbSelectedAll(false);

    if (item.name === "Không có tag") {
      const updatedTags = listTagBombot.map((it) => ({
        ...it,
        checked: it.name === "Không có tag"
      }));
      setListTagBombot(updatedTags);
    } else {
      const updatedTags = listTagBombot.map((it) => {
        if (it.name === "Không có tag") {
          return { ...it, checked: false };
        }
        if (it.id === item.id) {
          return { ...it, checked: !it.checked };
        }
        return it;
      });
      setListTagBombot(updatedTags);
    }
  };

  const handleCheckedTagFacebook = (item) => {
    setTagFbSelectedAll(false);

    if (item.name === "Không có tag") {
      const updatedTags = listTagFacebook.map((it) => ({
        ...it,
        checked: it.name === "Không có tag"
      }));
      setListTagFacebook(updatedTags);
    } else {
      const updatedTags = listTagFacebook.map((it) => {
        if (it.name === "Không có tag") {
          return { ...it, checked: false };
        }
        if (it.id === item.id) {
          return { ...it, checked: !it.checked };
        }
        return it;
      });
      setListTagFacebook(updatedTags);
    }
  };

  const handleClosePoup = () => {
    setIsPopup(false);
    setLastInboxTimeTo(null);
    setLastInboxTime(null);
    setLastCustomerInboxTimeTo(null);
    setLastCustomerInboxTime(null);
  };

  const handleDetail = (item) => {
    setIsActions(types.ACTIONS.DETAIL);
    onDetail(item);
    setIsPopup(true);
  };

  const handleEdit = (item, pagination) => {
    setIsActions(types.ACTIONS.EDIT);
    onDetail(item);
    setIsPopup(true);
    setPagination(pagination);
    // handleSubmitActions(item)
  };

  const handleExport = () => {
    if (!_.isEmpty(fanpageSelected)) {
      let excludeArr = [];
      customerCheck.forEach((item) => {
        if (item.checked) {
          excludeArr.push(item.uid);
        }
      });

      let searchQuery =
      filterCus?.search_string || `pageId==${fanpageSelected.id}`;

      if (!_.isEmpty(searchUidName)) {
        searchQuery += `;uid|name==${searchUidName}`;
      }

      onExport({
        fanpageSelected: fanpageSelected,
        exclude: excludeArr,
        search: searchQuery
      });
    }
  };

  const handleRemoveCustomer = async (t, payload) => {
    if (_.isEmpty(fanpageSelected)) return;
    if (payload?.selectAllPages) {
      await removeCustomer(
        {
          fanpageSelected,
          search: payload.search,
          selectAllPages: true
        },
        t
      );
      return;
    }
    const excludeArr = customerCheck.map((item) => item.uid).filter(Boolean);
    await removeCustomer(
      {
        fanpageSelected,
        search: urlSearchParamSearch,
        exclude: excludeArr
      },
      t
    );
  };

  const handleImport = () => {
    setIsImportPopup(true);
    setMessage("");
  };

  const handleFilter = (pagination) => {
    onDetail({});
    setIsActions(types.ACTIONS.FILTER);
    setIsPopup(true);
    setLastInboxTimeTo(null);
    setLastInboxTime(null);
    setLastCustomerInboxTimeTo(null);
    setLastCustomerInboxTime(null);
    setPagination(pagination);
  };
  const handleDownloadExcel = () => {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;
    window.open(`${baseUrl}api/v1.0/customer/customer-template.xlsx`, "_blank");
  };
  const handleCloseImport = () => {
    setIsImportPopup(false);
  };

  const sortListTag = (listTag) => {
    const noTag = (listTag || []).find((item) => item.name === "Không có tag");
    const otherTags = (listTag || []).filter(
      (item) => item.name !== "Không có tag"
    );
    const attachedTags = otherTags.filter((item) => item.checked);
    const unattachedTags = otherTags.filter((item) => !item.checked);

    attachedTags.sort((a, b) => a.name.localeCompare(b.name));
    unattachedTags.sort((a, b) => a.name.localeCompare(b.name));

    if (noTag) {
      return [noTag, ...attachedTags, ...unattachedTags];
    }

    return [...attachedTags, ...unattachedTags];
  };

  const handleSubmitOpenExtension = () => {
    let url =
      types.URL.FACEBOOK +
      `&token=${localStorage.getItem("token") || null}` +
      "&tab=scan";

    if (selectedPageId) {
      url += `&pageId=${selectedPageId}`;
    }

    window.open(url, "_blank");
  };

  const handleClickExtension = (url) => {
    window.open(url, "_blank");
    setOpenPopupScanCustomer(false)
  };

  const handleToggleScanCustomer = () => {
    setOpenPopupScanCustomer(!openPopupScanCustomer)
  }

  useEffect(() => {
    if (!fanpageSelected.id || selectedPageId) return;
    setSelectedPageId(fanpageSelected.id);
  }, [fanpageSelected]);

  //  WORKING CODE ---------------------
  const handleSubmitImportExcel = (event) => {
    const params = {
      file: file,
      fanpage: fanpageSelected,
      type: typeIdentif
    };
    fileUpload(params);
  };
  //  WORKING CODE ---------------------

  const handleFile = (event) => {
    setFile(event.target.files[0]);
  };

  const handleChange = (key, value) => {
    switch (key) {
      case "uid":
        setUid(value);
        break;
      case "nameFacebook":
        setNameFacebook(value);
        break;
      case "lastInboxTime":
        setLastInboxTime(value);
        break;
      case "lastInboxTimeTo":
        setLastInboxTimeTo(value);
        break;
      case "lastCustomerInboxTime":
        setLastCustomerInboxTime(value);
        break;
      case "lastCustomerInboxTimeTo":
        setLastCustomerInboxTimeTo(value);
        break;
      case "gender":
        setGender(value);
        break;
      case "addTagBombot":
        setAddTag(value);
        break;
      case "identification":
        setTypeIdentif(value);
        break;
      default:
        break;
    }
  };

  const handleSubmitActions = () => {
    let fbTagsArr = [];
    let bombotTagsArr = [];
    let fbTagsArrAll = [];
    let bombotTagsArrAll = [];
    let notInTagBombot = false;
    let notInTagFacebook = false;

    listTagBombot.map((it) => {
      if (it.checked) {
        bombotTagsArr.push(it.id);
      }
      if (it.checked && it.id == "not_in_tag") {
        notInTagBombot = true;
      }
      if (it.id != "not_in_tag" && !it.checked) {
        bombotTagsArrAll.push(it.id);
      }
    });

    listTagFacebook.map((it) => {
      if (it.checked) {
        fbTagsArr.push(it.id);
      }
      if (it.checked && it.id == "not_in_tag") {
        notInTagFacebook = true;
      }
      if (it.id != "not_in_tag" && !it.checked) {
        fbTagsArrAll.push(it.id);
      }
    });
    // console.log('notInTagFacebook', notInTagBombot, bombotTagsArr, bombotTagsArr.length)
    if (isActions == types.ACTIONS.EDIT) {
      const params = {
        id: detail.id,
        uid: uid,
        name: nameFacebook,
        pageId: detail.pageId,
        gender: gender,
        fbTags: fbTagsArr,
        bombotTags: bombotTagsArr,
        facebookTags: fbTagsArr,
        lastInboxTime: detail.lastInboxTime,
        lastCustomerInboxTime: detail.lastCustomerInboxTime
      };
      const searchParam = new URLSearchParams(window.location.search);
      const getSearch = searchParam.get("search");
      onEdit(params).then((res) => {
        if (res) {
          getCustomer({
            page: urlSearchParamPage,
            size: urlSearchParamSize,
            search: `${
              getSearch ? getSearch : `pageId==${fanpageSelected.id}`
            }`,
            // search: `pageId==${
            //   urlSearchParamPageId ? urlSearchParamPageId : fanpageSelected.id
            // }`,
            sort: urlSearchParamSort ? urlSearchParamSort : "lastInboxTime,desc"
          });
        }
      });
      // getCustomer(pagination);
    } else if (isActions == types.ACTIONS.FILTER) {
      let paramsSearch = `pageId==${fanpageSelected.id}`;
      if (uid != undefined) {
        paramsSearch = `${paramsSearch};uid==` + uid;
      }
      if (nameFacebook != undefined) {
        paramsSearch = `${paramsSearch};name==` + nameFacebook;
      }
      if (gender != undefined && gender != "all") {
        paramsSearch = `${paramsSearch};gender==` + _.upperCase(gender);
      }
      if (lastInboxTime) {
        paramsSearch = `${paramsSearch};lastInboxTime=bw=${lastInboxTime},${
          lastInboxTimeTo ? lastInboxTimeTo : lastInboxTime
        }`;
      }
      if (lastCustomerInboxTime) {
        paramsSearch = `${paramsSearch};lastCustomerInboxTime=bw=${lastCustomerInboxTime},${
          lastCustomerInboxTimeTo
            ? lastCustomerInboxTimeTo
            : lastCustomerInboxTime
        }`;
      }
      if (fbTagsArr.length > 0 && fbTagsArr.length < listTagFacebook.length) {
        paramsSearch = `${paramsSearch};fbTags=${
          notInTagFacebook ? "notin" : "in"
        }=${notInTagFacebook ? fbTagsArrAll.toString() : fbTagsArr.toString()}`;
      }
      if (
        bombotTagsArr.length > 0 &&
        bombotTagsArr.length < listTagBombot.length
      ) {
        paramsSearch = `${paramsSearch};bombotTags=${
          notInTagBombot ? "notin" : "in"
        }=${
          notInTagBombot
            ? bombotTagsArrAll.toString()
            : bombotTagsArr.toString()
        }`;
      }
      const params = {
        page: pagination.page,
        size: pagination.size,
        search: paramsSearch,
        sort: "lastInboxTime,desc"
      };
      // {"lastInboxTime":["2020-09-30T17:00:00.000Z","2021-05-10T17:00:00.000Z"],"gender":"all","bombotTags":["152053205","425833478"],"fbTags":[],"pageId":"472971019831648"}
      // query: JSON.stringify({
      //   lastInboxTime: [lastInboxTime, lastInboxTimeTo],
      //   gender: gender,
      //   pageId: fanpageSelected.id,
      //   bombotTags: Object.keys(bombotTagsArr) || [],
      //   fbTags: Object.keys(fbTagsArr) || [],
      // }),

      const paramsFilter = JSON.stringify({
        lastInboxTime: [lastInboxTime, lastInboxTimeTo],
        lastCustomerInboxTime: [lastCustomerInboxTime, lastCustomerInboxTimeTo],
        gender: gender,
        pageId: fanpageSelected.id,
        bombotTags: bombotTagsArr || [],
        fbTags: fbTagsArr || []
      });
      const searchParam = new URLSearchParams(window.location.search);
      searchParam.set("search", paramsSearch);
      searchParam.delete("query");
      searchParam.set("query", paramsFilter);
      searchParam.set("page", pagination.page);
      const newSearchParam = searchParam.toString();
      history.push({
        pathname: window.location.pathname,
        search: newSearchParam
      });
      setParamsFilter(paramsFilter);
      getCustomer(params);
    }
    setIsPopup(false);
  };
  const handleOpenAddTag = () => {
    setMessageAddTag("");
    setAddTag("");
    setIsAddTag(true);
  };
  const handleCloseAddTag = () => {
    setIsAddTag(false);
  };
  const handleDeteleTag = (item) => {
    setItemDelete(item);
    setIsConfirmDeleteTag(true);
  };

  const handleSubmitAddTag = () => {
    if (!/\S/.test(addTag)) {
      setMessageAddTag(t("update.noti.enter_tag"));
    } else {
      setMessageAddTag("");
      const checkAddTag = (obj) => obj.name === addTag;
      const checkTagExist = listTagBombot.some(checkAddTag);
      if (checkTagExist) {
        setMessageAddTag(t("update.noti.tag_existed"));
      } else {
        if (addTag) {
          let bombotTags = listTagBombot.length > 0 ? listTagBombot : [];
          const filtered = bombotTags.filter(function (el) {
            return el.id != "not_in_tag";
          });
          let dataBombotTag = [...filtered, { name: addTag }];
          let facebookTags =
            fanpageSelected && fanpageSelected.fbTags
              ? fanpageSelected && fanpageSelected.fbTags
              : [];
          const params = {
            id: fanpageSelected.id,
            name: fanpageSelected.name,
            fbTags: facebookTags,
            bombotTags: dataBombotTag
          };
          onSubmitAddTag(params);
          setAddTag("");
          setIsAddTag(false);
        }
      }
    }

    //   if (addTag)
    //   if(listTagBombot.indexOf(addTag) !== -1){
    //     alert("Value exists!")
    // } else{
    //     alert("Value does not exists!")
    // }
    // if (!/\S/.test(addTag)) {
    //   setMessageAddTag("Vui lòng nhập tên tag")
    // } else {
    //   setMessageAddTag("")
    //   if (addTag) {
    //     let bombotTags = listTagBombot.length > 0 ? listTagBombot : [];
    //     const filtered = bombotTags.filter(function(el) { return el.id != "not_in_tag" });
    //     let dataBombotTag = [...filtered, { name: addTag }];
    //     let facebookTags =
    //       fanpageSelected && fanpageSelected.fbTags
    //         ? fanpageSelected && fanpageSelected.fbTags
    //         : [];
    //     const params = {
    //       id: fanpageSelected.id,
    //       name: fanpageSelected.name,
    //       fbTags: facebookTags,
    //       bombotTags: dataBombotTag,
    //     };
    //     onSubmitAddTag(params);
    //     setAddTag("");
    //     setIsAddTag(false);
    //   }
    // }
  };
  const handleCloseConfirmDeleteTag = () => {
    setIsConfirmDeleteTag(false);
  };
  const handleConfirmDeleteTag = () => {
    let bombotTags = listTagBombot.length > 0 ? listTagBombot : [];
    const filtered = bombotTags.filter(function (el) {
      return el.id != "not_in_tag";
    });
    let dataBombotTag = filtered.filter(function (it) {
      return it.id != itemDelete.id;
    });
    let facebookTags =
      fanpageSelected && fanpageSelected.fbTags
        ? fanpageSelected && fanpageSelected.fbTags
        : [];
    const params = {
      id: fanpageSelected.id,
      name: fanpageSelected.name,
      fbTags: facebookTags,
      bombotTags: dataBombotTag
    };

    onSubmitAddTag(params);
    setAddTag("");
    setIsAddTag(false);
    setIsConfirmDeleteTag(false);
  };

  const handleParamsPagination = (params) => {
    setUrlSearchParamPage(params.page - 1);
    setUrlSearchParamSize(params.size);
    setUrlSearchParamPageId(params.pageId);
  };

  const [customerState, setCustomerState] = useState([]);

  return (
    <MainLayout>
      <Tour
        steps={tourConfig}
        closeWithMask={false}
        lastStepNextButton={
          <Button size="small" className="btn--rounder" variant="contained">
            {t("common.btn.close")}
          </Button>
        }
        isOpen={tourConfig != null}
        accentColor="#05ae34"
        onRequestClose={() => setTourConfig(null)}
      />
      {/* <input type="file" onChange={fileHandler} style={{"padding":"10px"}} /> */}
      {loading && <Loading />}
      <FormDialog isOpen={isAddTag} handleClose={() => handleCloseAddTag()}>
        <div className={cn(classes.wrapBox, "p-4")}>
          <h4 className={classes.title}>
            {t("customer_management.add_bombot_tag.insert_tag_name")}
          </h4>
          <TextField
            error={false}
            label={t("customer_management.add_bombot_tag.insert_tag_name")}
            variant="outlined"
            size="small"
            className={classes.addTag}
            defaultValue={addTag}
            onChange={(event) =>
              handleChange("addTagBombot", event.target.value)
            }
          />
          {messageAddTag && (
            <p style={{ textAlign: "center", color: "red" }}>{messageAddTag}</p>
          )}
          <div className={classes.wrapButtonImport}>
            <ButtonComponent
              className={cn(classes.buttonChange, "btn--rounder")}
              title={t("common.btn.save")}
              backgroundColor="#05AE34"
              color="white"
              handleClickButton={() => handleSubmitAddTag()}
              disabled={loadingImport ? true : false}
            />
          </div>
        </div>
      </FormDialog>
      <FormDialog
        isOpen={isConfirmDeleteTag}
        // handleClose={() => handleCloseInviteCodePopup()}
      >
        <div className={classes.wrapChangePassword}>
          {/* <h4 className={classes.titlePopup}>
            Xác nhân
          </h4> */}
          <p style={{ padding: "15px 15px 0px 15px", textAlign: "center" }}>
            {t("update.delete_tag.desc")}?
          </p>
          <div className={cn(classes.wrapButtonPopup, "mt-4")}>
            <ButtonComponent
              size="small"
              className="btn--rounder mr-2"
              title={t("common.btn.cancel")}
              backgroundColor="#BDBDBD"
              color="white"
              handleClickButton={() => handleCloseConfirmDeleteTag()}
            />
            <ButtonComponent
              size="small"
              className="btn--rounder"
              variant="contained"
              title={t("common.btn.confirm")}
              backgroundColor="#05AE34"
              color="white"
              handleClickButton={() => handleConfirmDeleteTag()}
            />
          </div>
        </div>
      </FormDialog>
      <FormDialog
        isOpen={isImportPopup}
        width="520px"
        withoutHeader
        handleClose={() => handleCloseImport()}
      >
        <div>
          {/* Modal Header */}
          <div className={listStyles.modalHd}>
            <div className={listStyles.modalTitle}>{t('customer_page.import_title')}</div>
            <button className={listStyles.modalClose} onClick={() => handleCloseImport()}>
              <svg viewBox="0 0 14 14"><path d="M3 3l8 8M11 3l-8 8"/></svg>
            </button>
          </div>

          {/* Modal Body */}
          <div className={listStyles.modalBd}>
            <label className={listStyles.dropzone}>
              <input
                type="file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={handleFile}
                style={{ display: "none" }}
              />
              <svg viewBox="0 0 24 24"><path d="M12 16V6m0 0l-4 4m4-4l4 4M4 18v1a2 2 0 002 2h12a2 2 0 002-2v-1"/></svg>
              <div className={listStyles.dzTitle}>
                {file?.name ? t('customer_page.import_file_selected', { name: file.name }) : t('customer_page.import_dropzone')}
              </div>
              <div className={listStyles.dzSub}>
                {t('customer_page.import_max')}{" "}
                <a
                  href="#"
                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDownloadExcel(); }}
                  style={{ color: "var(--green-dark, #16A34A)", fontWeight: 600 }}
                >
                  {t('customer_page.import_download_template')}
                </a>
              </div>
            </label>

            <div style={{ marginTop: 16 }}>
              <label className={listStyles.formLbl}>{t('customer_page.import_id_field_label')}</label>
              <div className={listStyles.radioList}>
                {[
                  ["CONVERSATION_ID", "Conversation_ID", t('customer_page.import_recommended')],
                  ["UID", "UID"],
                  ["PHONE", t('customer_management.import_customer.phone')],
                  ["FULLNAME_PHONE", t('customer_management.import_customer.name_phone')],
                  ["FULLNAME_LASTINBOX", t('customer_management.import_customer.name_last_inbox_time')],
                  ["FULLNAME_GENGER", t('customer_management.import_customer.name_gender')],
                  ["FULLNAME_LASTCUSTOMERINBOX", t('customer_management.import_customer.name_last_customer_inbox_time')]
                ].map(([val, lbl, hint]) => (
                  <label key={val} className={listStyles.radioRow}>
                    <input
                      type="radio"
                      name="idField"
                      checked={typeIdentif === val}
                      onChange={() => handleChange("identification", val)}
                    />
                    <span>
                      {lbl} {hint && <span style={{ color: "var(--text-tertiary, #9CA3AF)", fontSize: 11 }}>{hint}</span>}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            {loadingImport && (
              <div className={classes.wrapperLoading} style={{ marginTop: 12 }}>
                <img src={IMAGES.LOADING} alt="loading" />
                <p>{t("update.import_customer.loading")}</p>
              </div>
            )}
            {!loadingImport && message && (
              <p style={{ color: "red", textAlign: "center", marginTop: 12, fontSize: 12 }}>
                {message}
              </p>
            )}
          </div>

          {/* Modal Footer */}
          <div className={listStyles.modalFt}>
            <button className={cn(listStyles.btn, listStyles.btnGhost)} onClick={() => handleCloseImport()} disabled={loadingImport}>
              {t('common.btn.cancel')}
            </button>
            <button className={cn(listStyles.btn, listStyles.btnPrimary)} onClick={() => handleSubmitImportExcel()} disabled={loadingImport}>
              {t('customer_page.import_btn_submit')}
            </button>
          </div>
        </div>
      </FormDialog>
      {/* V3: Page Head with action buttons */}
      <div className={listStyles.pageHead}>
        <div>
          <div className={listStyles.pageTitle}>{t('customer_page.page_title')}</div>
          <div className={listStyles.pageSub}>
            {fanpageSelected?.name
              ? t('customer_page.page_sub_fanpage', { total: (data?.totalElements || 0).toLocaleString("vi-VN"), name: fanpageSelected.name })
              : t('customer_page.page_sub_default')}
          </div>
        </div>
        <div className={listStyles.pageActions}>
          <button id="import_customer" className={cn(listStyles.btn, listStyles.btnGhost)} onClick={() => handleImport()} disabled={_.isEmpty(fanpageSelected)}>
            <svg viewBox="0 0 14 14" fill="none"><path d="M7 10V2m0 8L4.5 7.5M7 10l2.5-2.5M2 11.5v.5A1.5 1.5 0 003.5 13.5h7A1.5 1.5 0 0012 12v-.5"/></svg>
            <span>{t("common.btn.import_customer")}</span>
          </button>
          <button id="export_customer" className={cn(listStyles.btn, listStyles.btnGhost)} onClick={() => handleExport()} disabled={_.isEmpty(fanpageSelected)}>
            <svg viewBox="0 0 14 14" fill="none"><path d="M7 2v8m0 0l2.5-2.5M7 10L4.5 7.5M2 11.5v.5A1.5 1.5 0 003.5 13.5h7A1.5 1.5 0 0012 12v-.5"/></svg>
            <span>{t("common.btn.export_customer")}</span>
          </button>
          <button className={cn(listStyles.btn, listStyles.btnGhost)} onClick={() => handleToggleScanCustomer()}>
            <svg viewBox="0 0 14 14" fill="none"><circle cx="6.5" cy="6.5" r="4.5"/><path d="M13 13l-3-3"/></svg>
            <span>{t("common.btn.scan_customer")}</span>
          </button>
          <button id="create_campaign" className={cn(listStyles.btn, listStyles.btnPrimary)} onClick={() => setIsCreateCampaign(true)} disabled={_.isEmpty(fanpageSelected)}>
            <svg viewBox="0 0 14 14" fill="none"><path d="M7 2v10M2 7h10"/></svg>
            <span>{t("customer_management.create_campaign.title")}</span>
          </button>
        </div>
      </div>

      {/* Scan customer dialog */}
      <Dialog open={openPopupScanCustomer} maxWidth="xs" classes={{ paper: classes.dialog }}>
        <LoadingWrapper isOpen={isLoading}>
          {/* Close button */}
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={handleToggleScanCustomer}
            style={{ position: 'absolute', top: 10, right: 10, zIndex: 1 }}
          >
            <X size={16} />
          </IconButton>

          {/* Icon */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '32px 28px 0' }}>
            <div style={{
              width: 52, height: 52, borderRadius: '50%',
              background: '#DCFCE7',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              marginBottom: 12,
            }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="#16A34A" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 26, height: 26 }}>
                <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                <path d="M2 12l10 5 10-5"/>
                <path d="M2 17l10 5 10-5"/>
              </svg>
            </div>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#111827', marginBottom: 10, textAlign: 'center' }}>
              {t("customer_page.ext_check_title")}
            </div>
            <p style={{ fontSize: 13, lineHeight: 1.7, color: '#6B7280', textAlign: 'center', margin: '0 0 24px' }}>
              {t("common.btn.scan_customer_dialog_1")}{" "}
              <a
                href="https://hotro.bombot.vn/knowledgebase/huong-dan-cai-dat-phien-ban-moi-ung-dung-gui-tin-hang-loat-bombot-vn/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#16A34A', fontWeight: 600, textDecoration: 'none' }}
                onClick={() => setOpenPopupScanCustomer(false)}
              >
                {t("common.btn.see_detail")}
              </a>{" "}
              {t("common.btn.scan_customer_dialog_2")}
            </p>
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', gap: 10, padding: '0 28px 28px' }}>
            <button
              onClick={() => handleClickExtension(types.URL.EXTENSION)}
              style={{
                flex: 1, padding: '10px 0',
                border: '1px solid #E5E7EB', background: '#fff',
                borderRadius: 8, fontSize: 13, fontWeight: 600,
                color: '#6B7280', cursor: 'pointer', fontFamily: 'inherit',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                transition: 'border-color 0.12s, color 0.12s',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = '#22C55E'; e.currentTarget.style.color = '#16A34A'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = '#E5E7EB'; e.currentTarget.style.color = '#6B7280'; }}
            >
              <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.8" style={{ width: 13, height: 13, flexShrink: 0 }}>
                <path d="M7 2v8m0 0l-3-3m3 3l3-3M2 11.5v.5A1.5 1.5 0 003.5 13.5h7A1.5 1.5 0 0012 12v-.5"/>
              </svg>
              {t("common.btn.install_download_file")}
            </button>
            <button
              onClick={handleSubmitOpenExtension}
              style={{
                flex: 1, padding: '10px 0',
                border: 'none', background: '#22C55E',
                borderRadius: 8, fontSize: 13, fontWeight: 700,
                color: '#fff', cursor: 'pointer', fontFamily: 'inherit',
                transition: 'background 0.12s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = '#16A34A'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#22C55E'; }}
            >
              {t("common.btn.continue")} →
            </button>
          </div>
        </LoadingWrapper>
      </Dialog>

      {/* Hidden Autocomplete — drives fanpageSelected state */}
      <div style={{ display: "none" }}>
        <Autocomplete
          freeSolo
          options={fanpageFull}
          onChange={(_, data) => { setSelectedPageId(data?.id || null); handleChangeFanpage("fanpage", data); }}
          getOptionLabel={(option) => option?.name || ""}
          value={fanpageSelected || null}
          renderInput={(params) => <TextField {...params} size="small" label={t("customer_management.choose_page")} variant="outlined" />}
        />
      </div>
      <ListCustomerComponent
        // handleGetData={(params) => handleGetData(params)}
        getData={(params) => getCustomer(params)}
        getFanpage={getFanpage}
        data={data}
        fanpageFull={fanpageFull}
        onChangeFanpage={(data) => { setSelectedPageId(data?.id || null); handleChangeFanpage("fanpage", data); }}
        fanpageSelected={fanpageSelected}
        detail={(item) => handleDetail(item)}
        edit={(item, params) => handleEdit(item, params)}
        handleExport={() => handleExport()}
        handleImport={() => handleImport()}
        handleRemoveCustomer={(payload) => handleRemoveCustomer(t, payload)}
        handleFilter={(value) => handleFilter(value)}
        onCreate={(paramsFilter, rows, params, data, isUseCheckedAllPage, activeSearch) =>
          onCreate(paramsFilter, rows, params, data, isUseCheckedAllPage, activeSearch)
        }
        isCreateCampaign={isCreateCampaign}
        onCloseCreateCampaign={() => setIsCreateCampaign(false)}
        customerAll={customerAll}
        onCustomerCheck={onCustomerCheck}
        customerCheck={customerCheck}
        onCustomerCheckReset={onCustomerCheckReset}
        createCustomerSucss={createCustomerSucss}
        paramsFilter={paramsFilter}
        paramsPagination={(params) => handleParamsPagination(params)}
        customerState={customerState}
      />
      <FormDialog isOpen={isPopup} width="520px" withoutHeader handleClose={() => handleClosePoup()}>
        <div>
          {/* Modal Header */}
          <div className={listStyles.modalHd}>
            <div className={listStyles.modalTitle}>
              {isActions === types.ACTIONS.DETAIL ? t('update.cus_info.title_detail') : t('update.cus_info.title_edit')}
            </div>
            <button className={listStyles.modalClose} onClick={() => handleClosePoup()}>
              <svg viewBox="0 0 14 14"><path d="M3 3l8 8M11 3l-8 8"/></svg>
            </button>
          </div>

          {/* Modal Body */}
          <div className={listStyles.modalBd}>
            <div className={listStyles.formGrid}>
              {/* UID */}
              <div className={listStyles.formField}>
                <label className={listStyles.formLbl}>UID</label>
                <input
                  className={listStyles.formInput}
                  readOnly
                  value={detail?.uid || ''}
                />
              </div>

              {/* Họ tên Facebook */}
              <div className={listStyles.formField}>
                <label className={listStyles.formLbl}>{t('customer_page.field_name')} *</label>
                <input
                  className={listStyles.formInput}
                  defaultValue={detail?.name || ''}
                  disabled={isActions === types.ACTIONS.DETAIL}
                  onChange={(e) => handleChange('nameFacebook', e.target.value)}
                />
              </div>

              {/* Số điện thoại */}
              <div className={listStyles.formField}>
                <label className={listStyles.formLbl}>{t('customer_page.field_phone')}</label>
                <input
                  className={listStyles.formInput}
                  defaultValue={detail?.phone || ''}
                  disabled={isActions === types.ACTIONS.DETAIL}
                  placeholder={t('customer_page.field_phone_none')}
                  onChange={(e) => handleChange('phone', e.target.value)}
                />
              </div>

              {/* Giới tính */}
              <div className={listStyles.formField}>
                <label className={listStyles.formLbl}>{t('customer_page.field_gender')}</label>
                <div className={listStyles.segGroup}>
                  {[['MALE', t('update.gender.male')], ['FEMALE', t('update.gender.female')], ['NEUTER', t('update.gender.other')]].map(([val, lbl]) => (
                    <button
                      key={val}
                      type="button"
                      disabled={isActions === types.ACTIONS.DETAIL}
                      onClick={() => handleChange('gender', val)}
                      className={clsx(listStyles.segBtn, gender === val && listStyles.segBtnActive)}
                    >
                      {lbl}
                    </button>
                  ))}
                </div>
              </div>

              {/* Tag Bombot */}
              <div className={listStyles.formFieldFull}>
                <label className={listStyles.formLbl}>{t('customer_page.field_tag_bombot')}</label>
                <div className={listStyles.tagPool}>
                  {listTagBombot.length > 0 ? listTagBombot.filter(tg => tg.id !== 'not_in_tag').map((tag, idx) => (
                    <span
                      key={idx}
                      onClick={() => isActions !== types.ACTIONS.DETAIL && handleCheckedTagBombot(tag)}
                      className={clsx(listStyles.tagPick, tag.checked && listStyles.tagPickOn)}
                      style={
                        tag.checked && (tag.backgroundColor || tag.color)
                          ? {
                              background: tag.backgroundColor || `#${tag.color}`,
                              borderColor: tag.backgroundColor || `#${tag.color}`,
                              color: tag.textColor || '#fff'
                            }
                          : {}
                      }
                    >
                      {tag.name}
                      {tag.checked && isActions === types.ACTIONS.EDIT && (
                        <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 10, height: 10, marginLeft: 2 }} onClick={(e) => { e.stopPropagation(); handleDeteleTag(tag); }}><path d="M2 2l8 8M10 2l-8 8"/></svg>
                      )}
                    </span>
                  )) : <span className={listStyles.tagNone}>{t('customer_page.no_tag')}</span>}
                </div>
                {isActions === types.ACTIONS.EDIT && (
                  <button className={listStyles.btnAddTag} onClick={handleOpenAddTag} type="button">
                    <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 1v10M1 6h10"/></svg>
                    {t('customer_page.btn_add_tag')}
                  </button>
                )}
              </div>

              {/* Tag Facebook (chỉ xem) */}
              <div className={listStyles.formFieldFull}>
                <label className={listStyles.formLbl}>{t('customer_page.field_tag_facebook_readonly')}</label>
                <div className={listStyles.tagsCell} style={{ maxWidth: 'none', background: 'var(--surface-alt, #F9FAFB)', padding: '8px 10px', border: '1px solid var(--border, #E5E7EB)', borderRadius: 'var(--radius-md, 8px)', minHeight: 36 }}>
                  {listTagFacebook.filter(tg => tg.checked).length > 0
                    ? listTagFacebook.filter(tg => tg.checked).map((tag, idx) => (
                      <span key={idx} className={clsx(listStyles.tagMini, listStyles.tagFb)} style={tag.backgroundColor || tag.color ? { background: tag.backgroundColor || `#${tag.color}`, color: tag.textColor || '#fff' } : {}}>{tag.name}</span>
                    ))
                    : <span className={listStyles.tagNone}>{t('customer_page.no_tag_facebook')}</span>
                  }
                </div>
                <div className={listStyles.formNote}>
                  <svg viewBox="0 0 14 14"><circle cx="7" cy="7" r="5.5"/><path d="M7 6.5v3M7 4.5h.01"/></svg>
                  {t('customer_page.tag_facebook_note')}
                </div>
              </div>
            </div>
          </div>

          {/* Modal Footer */}
          <div className={listStyles.modalFt}>
            <button className={clsx(listStyles.btn, listStyles.btnGhost)} onClick={() => handleClosePoup()}>{t('common.btn.cancel')}</button>
            {isActions !== types.ACTIONS.DETAIL && (
              <button className={clsx(listStyles.btn, listStyles.btnPrimary)} onClick={() => handleSubmitActions()}>{t('customer_page.btn_save_changes')}</button>
            )}
          </div>
        </div>
      </FormDialog>
      {importResult && <ModalResultImport data={importResult} />}
      <MessengerButton />
    </MainLayout>
  );
};

function InputComponent({ defaultValue, inputRef, ...props }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(null);
  const handleChange = (event) => {
    setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  };
  return (
    <div className={classes.root} style={{ width: "100%" }}>
      <div
        className={classes.display}
        style={{
          display: "inline-block",
          position: "absolute",
          background: "white",
          top: "0px",
          height: "40px",
          width: "100px",
          lineHeight: "40px"
        }}
      >
        {value != null && moment(value).format("DD/MM/YYYY")}
      </div>
      <input
        className={classes.input}
        ref={inputRef}
        {...props}
        onChange={handleChange}
        value={moment(value).format("YYYY/MM/DD")}
      />
    </div>
  );
}

CustomerView.propTypes = {};

CustomerView.defaultProps = {};

export default CustomerView;
